import { ActionContext } from 'vuex';

export default {
	namespaced: true,
	state: {
		id: -999,
		name: '',
		email: '',
		mobileNumber: '',
		roles: [],
		isAdmin: false,
		isRpaUser: false,
		isCreateUser: false,
		isAiUser: false,
		isConverseCxUser: false,
		isSparkUser: false,
		isIdpUser: false,
		isReportingUser: false,
		isManualLoginDenied: false,
		isMultiTenant: false,
		isNetcallUser: false,
		isLoggedIn: false,
		everLoggedIn: false,	// set to true on login, persists after logout
		logoutReason: '',	// manual | unauthorised | unknown
		temp_id: '',
		preferred2faMethod: '',
		isTotpAuthenticationEnabled: false,
		totpConfigured: false,
	},
	mutations: {
		SET_DETAILS: (state: any, account: any) => {
			state.id = account.id || -999;
			state.name = account.name || '';
			state.email = account.email || '';
			state.mobileNumber = account.mobileNumber || '';
			state.roles = account.roles || [];
			state.isAdmin = account.isAdmin || false;
			state.isRpaUser = account.isRpaUser || false;
			state.isCreateUser = account.isCreateUser || false;
			state.isAiUser = account.isAiUser || false;
			state.isConverseCxUser = account.isConverseCxUser || false;
			state.isSparkUser = account.isSparkUser || false;
			state.isIdpUser = account.isIdpUser || false;
			state.isReportingUser = account.isReportingUser || false;
			state.isManualLoginDenied = account.isManualLoginDenied || false;
			state.isMultiTenant = account.isMultiTenant || false;
			state.isNetcallUser = account.isNetcallUser || false;
			state.isLoggedIn = true;
			state.everLoggedIn = true;
			state.logoutReason = '';
			state.temp_id = '';
			state.preferred2faMethod = account.preferred2faMethod || '';
			state.isTotpAuthenticationEnabled = account.isTotpAuthenticationEnabled || false;
			state.totpConfigured = account.totpConfigured || false;
		},

		SET_TEMP: (state: any, id: number) => {
			state.temp_id = id;
		},

		RESET_TEMP: (state: any) => {
			state.temp_id = false;
		},

		RESET: (state: any, reason: string) => {
			state.id = -999;
			state.name = '';
			state.email = '';
			state.mobileNumber = '';
			state.roles = [];
			state.isAdmin = false;
			state.isRpaUser = false;
			state.isCreateUser = false;
			state.isAiUser = false;
			state.isConverseCxUser = false;
			state.isSparkUser = false;
			state.isIdpUser = false;
			state.isReportingUser = false;
			state.isManualLoginDenied = false;
			state.isMultiTenant = false;
			state.isNetcallUser = false;
			state.isLoggedIn = false;
			state.logoutReason = reason || 'unknown';
			state.temp_id = '';
		},
	},
	actions: {
		set: (context: ActionContext<any, any>, account: any) => {
			context.commit('SET_DETAILS', account);
		},

		set_temp: (context: ActionContext<any, any>, id: number) => {
			context.commit('SET_TEMP', id);
		},

		reset_temp: (context: ActionContext<any, any>) => {
			context.commit('RESET_TEMP');
		},

		logout: (context: ActionContext<any, any>, reason: string) => {
			context.commit('RESET', reason);
		},
	},
};
